var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[(_vm.isLoading)?_c('LoadingContainer',{staticClass:"box--mini"}):_c('div',[(!_vm.hasBillboard && (!_vm.hasUserSubscriptionAccess && !_vm.subscription.is_pending))?_c('WelcomeBox',{staticClass:"header-gap"}):(_vm.hasBillboard)?_c('Billboard',{attrs:{"items":_vm.billboard}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }